import type { PersistedContact } from "schemas";
import { apiRequest } from "../apiRequest";
import { setContact } from "./setContact";

export async function getContact(id: string) {
  const contact = await apiRequest<PersistedContact>({ url: `contacts/${id}` });
  setContact(contact);
}
